module.exports = __webpack_public_path__ + "img/Special Bets.35dc93b1.svg";